import React from 'react';
import { StyleSheet, View, } from 'react-native';
import Text from 'design-system/Text';
import { CardView } from 'design-system/CardView';
import { LineSeparator } from 'design-system/LineSeparator';
import { rem } from 'design-system/values';
export const SettingsSection = React.memo(({ children, name, renderHeader, title, withBottomMargin, noMarginTop, smallMarginTop, midMarginTop, renderTitle, style, pointerEvents, ...props }) => (<View style={[
        styles.container,
        withBottomMargin && styles.withBottomMargin,
        smallMarginTop && styles.smallMarginTop,
        midMarginTop && styles.midMarginTop,
        noMarginTop && styles.noMarginTop,
        style,
    ]} pointerEvents={pointerEvents}>
      {name ? (<Text Gray Text-16 style={styles.text}>
          {name}
        </Text>) : null}
      {!!renderHeader && renderHeader()}
      {/* Rows bring their own padding, so on web the card adds 8 around them. A section
    withPadding holds content directly and keeps its 16. */}
      <CardView {...props} style={styles.cardView} webPadding={!props.withPadding}>
        {renderTitle || title ? (<View>
            {renderTitle ? (renderTitle()) : (<View style={styles.titleContainer}>
                <Text Text-16>{title}</Text>
              </View>)}
            <LineSeparator style={styles.lineSeparator}/>
          </View>) : null}
        {children}
      </CardView>
    </View>));
const styles = StyleSheet.create({
    container: {
        marginTop: rem(24),
        marginHorizontal: rem(16),
    },
    noMarginTop: {
        marginTop: 0,
    },
    smallMarginTop: {
        marginTop: rem(8),
    },
    midMarginTop: {
        marginTop: rem(16),
    },
    withBottomMargin: {
        marginTop: 0,
        marginBottom: rem(24),
    },
    titleContainer: {
        padding: rem(16),
    },
    cardView: {
        margin: 0,
        overflow: 'hidden',
    },
    lineSeparator: {
        marginHorizontal: 0,
    },
    text: {
        paddingBottom: rem(16),
    },
});
